import React, {useEffect} from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';

import logoEmpresa from "../../assets/img/logo-tc-negro.png"

// Font.register({ family: 'Source Serif Pro', src: 'http://fonts.gstatic.com/s/sourceserifpro/v4/CeUM4np2c42DV49nanp55aqQQDHDiKO-LH8MFmRo0b0.ttf' });

const styles = StyleSheet.create({
  page: {
    paddingTop: 15,
    paddingBottom: 20,
    paddingHorizontal: 30,
    backgroundColor: '#fff',
  },
  header: {
    marginBottom: 10,
    alignItems: 'center',
  },
  logo: {
    width: 150,   // ajustá según tu logo
    height: 130,
    objectFit: 'contain',
  },
  remitente: {
    fontSize: 10,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 2,
    fontSize: 10,
    marginBottom: 5,
  },
  colToComplete: {
    borderBottom: 1,
    borderStyle: 'dashed',
    fontSize: 10,
  },
  
  colA: {
    width: '33%',
    fontWeight: 'bold',
  },
  colB: {
    width: '77%',
    borderBottom: 1,
    borderStyle: 'dashed',
    fontSize: 12,
  },
  colLabel: {
    fontWeight: 'bold',
  },

  colTopBorder: {
    borderTop: 1,
    borderStyle: 'dashed',
    marginRight: 20,
  },

  titulo: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'left', // opcional
  },

  content: {
    top: 12,
    flexDirection: 'row',
    // fontSize: 10,
    // marginBottom: 20,
  },
  contentGrid: {
    width: '100%',
    top: 50,
    fontSize: 10,
    // marginBottom: 20,
    // lineHeight: 1.5
  },
  boldText: {
    fontWeight: 'bold',
  },
  textoCabecera: {
    fontSize: 10,
    // fontWeight: 'bold',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },

  colCentro: {
    width: '50%',
    textAlign: 'center',
  },
  colDerecha: {
    width: '30%',
    textAlign: 'right',
  },
  subtituloHeader: {
    fontSize: 9,
  },

});

// PAGE SIZE: https://github.com/diegomura/react-pdf/blob/master/packages/layout/src/page/getSize.ts

const RptDeclaracionJuradaObligado = ({resource, preferencias, declaracionJurada}) => {
    const fecha = new Date();
    const hoy = fecha.getDate();
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    const dias = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
    const mesActual = fecha.getMonth();
    const diaActual = fecha.getDay();

    const fecha_actual = `${dias[diaActual]}, ${String(hoy)} de ${meses[mesActual]} de ${fecha.getFullYear()}`

    const fechaNacimiento = preferencias.f_nacimiento
      ? (() => {
          const [anio, mes, dia] = preferencias.f_nacimiento.split('-')
          return `día: ${dia} mes: ${mes} año: ${anio}`
        })()
      : null

    const fechaCargoDesde = declaracionJurada.f_cargo_desde
      ? (() => {
          const [anio, mes, dia] = declaracionJurada.f_cargo_desde.split('-')
          return `${dia} / ${mes} / ${anio}`
        })()
      : null

    const fechaCargoHasta = declaracionJurada.f_cargo_hasta
      ? (() => {
          const [anio, mes, dia] = declaracionJurada.f_cargo_hasta.split('-')
          return `${dia} / ${mes} / ${anio}`
        })()
      : null


    return (
        <Document>
          <Page size="LEGAL" style={styles.page}>

            <View style={styles.header}>
              <Image style={styles.logo} src={logoEmpresa} />
            </View>


            {/* REMITENTE */}
            <View style={{ marginBottom: 10 }}>
              <View style={{...styles.remitente, textAlign: 'right'}}>
                <Text>{fecha_actual}</Text>
              </View>
              <View style={styles.remitente}>
                <Text>Al Sr. Presidente</Text>
              </View>
              <View style={styles.remitente}>
                <Text>Tribunal de Cuentas de la Provincia</Text>
              </View>
              <View style={styles.remitente}>
                <Text>Dr. Juan Pablo Dirr</Text>
              </View>
              <View style={styles.remitente}>
                <Text>S________________/________________D:</Text>
              </View>
            </View>

            {/* EN MI CARACTER DE */}
            <View style={{ marginBottom: 15 }}>
              <View style={{...styles.row, paddingTop: 10, marginLeft: 100}}>
                <Text style={{...styles.colToComplete, width: '33%'}}>En mi caracter de</Text>
                <Text style={{...styles.colToComplete, width: '67%'}}>{declaracionJurada.cargo}</Text>
              </View>
              <View style={{...styles.row, paddingTop: 10 }}>
                <Text style={{...styles.colToComplete, width: '100%'}}>&nbsp;</Text>
              </View>
              <View style={{...styles.row, paddingTop: 10}}>
                <Text style={{...styles.colToComplete, width: '10%'}}>de</Text>
                <Text style={{...styles.colToComplete, width: '90%'}}>{declaracionJurada.organismo}</Text>
              </View>
            </View>

            {/* ME DIRIJO A USTED */}
            <View style={{ marginBottom: 10 }}>
                <Text style={{fontSize: 10}}>Me dirijo a Ud. con el fin de:</Text>
            </View>


            {/* PUNTO 1 */}
            <View style={{ marginTop: 10 }}>
              <View style={{...styles.row, }}>
                <Text style={{width: '100%'}}>1) Denunciar mis datos personales como responsable-obligado a rendir cuenta mientras dure mi mandato.</Text>
              </View>
              <View style={{marginLeft: 30}}>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '50%'}}>NOMBRE: {resource.nombre}</Text>
                  <Text style={{...styles.colToComplete, width: '50%'}}>APELLIDO: {resource.apellido}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5 }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>NACIONALIDAD: {preferencias.nacionalidad}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '30%'}}>FECHA DE NACIMIENTO: </Text>
                  <Text style={{...styles.colToComplete, width: '70%'}}>{fechaNacimiento}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '20%'}}>DOCUMENTO: </Text>
                  <Text style={{...styles.colToComplete, width: '80%'}}>Tipo: {preferencias.tipo_doc} N°: {resource.documento_identidad} </Text>
                </View>
                <View style={{...styles.row, paddingTop: 5 }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>ESTADO CIVIL: {preferencias.estado_civil}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '50%'}}>NOMBRE DEL CONYUGE: {preferencias.nombre_conyuge}</Text>
                  <Text style={{...styles.colToComplete, width: '50%'}}>APELLIDO DEL CONYUGE: {preferencias.apellido_conyuge}</Text>
                </View>
              </View>
            </View>

            {/* PUNTO 2 */}
            <View style={{ marginTop: 20 }}>
              <View style={{...styles.row, }}>
                <Text style={{width: '100%'}}>
                  2) Que a los fines previstos en el Art. 98º y 106º de la Ley 2141/95 de Administración Financiera y Control, 
                  denuncio el <Text style={{ fontWeight: 'bold', textDecoration: 'underline' }}>domicilio real</Text> (consignar: calle, número, barrio, lote, chacra, casa Nº, departamento, etc.,
                  según corresponda, localidad, código postal y croquis ilustrativo de ubicación del domicilio)
                </Text>
              </View>
              <View style={{marginLeft: 30}}>
                <View style={{...styles.row, paddingTop: 5 }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>CALLE y NUMERO: {preferencias.calle_real}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>BARRIO/LOTE/CHACRA: {preferencias.barrio_real}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '70%'}}>LOCALIDAD: {preferencias.localidad_real}</Text>
                  <Text style={{...styles.colToComplete, width: '30%'}}>CP: {preferencias.cp_real}</Text>
                </View>
              </View>
            </View>

            {/* PUNTO 3 */}
            <View style={{ marginTop: 20 }}>
              <View style={{...styles.row, }}>
                <Text style={{...styles.colToComplete, width: '100%'}}>
                  3) Hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente desde: {fechaCargoDesde}
                </Text>
              </View>
              <View style={{marginLeft: 30}}>
                <View style={{...styles.row, paddingTop: 5 }}>
                  <Text style={{...styles.colToComplete, width: '70%'}}>(Norma Legal de alta Nº. {declaracionJurada.numero_alta_norma_legal} )</Text>
                  <Text style={{...styles.colToComplete, width: '30%'}}> hasta: {fechaCargoHasta}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '95%'}}>(si corresponde) (Norma Legal de baja Nº. {declaracionJurada.numero_baja_norma_legal} )</Text>
                  <Text style={{...styles.colToComplete, width: '5%'}}> </Text>
                </View>
              </View>
            </View>

            {/* PUNTO 4 */}
            <View style={{ marginTop: 20 }}>
              <View style={{...styles.row, }}>
                <Text style={{width: '100%'}}>
                  4) Constituyo <Text style={{ fontWeight: 'bold', textDecoration: 'underline' }}>domicilio legal</Text> (consignar: calle, número, barrio, lote, chacra, casa Nº, departamento, etc., según corresponda, localidad, código postal y croquis ilustrativo de ubicación del domicilio):
                </Text>
              </View>
              <View style={{marginLeft: 30}}>
                <View style={{...styles.row, paddingTop: 5 }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>CALLE y NUMERO: {preferencias.calle_legal}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>BARRIO/LOTE/CHACRA: {preferencias.barrio_legal}</Text>
                </View>
                <View style={{...styles.row, paddingTop: 5}}>
                  <Text style={{...styles.colToComplete, width: '70%'}}>LOCALIDAD: {preferencias.localidad_legal}</Text>
                  <Text style={{...styles.colToComplete, width: '30%'}}>CP: {preferencias.cp_legal}</Text>
                </View>
              </View>
            </View>


            {/* FIRMAS */}
            <View style={{ marginTop: 60 }}>
              <View style={styles.row}>
                <Text style={{...styles.colLabel, width: '60%'}}></Text>
                <Text style={{...styles.colTopBorder, width: '40%', textAlign: 'right', paddingTop: 10}}>(firma y aclaración)</Text>
              </View>
            </View>

            {/* SEGUNDA HOJA */}
            <View break>
              <View style={styles.header}>
                <Image style={styles.logo} src={logoEmpresa} />
              </View>

              {/* PUNTO 5 */}
              <View style={{ marginTop: 10 }}>
                <View style={{...styles.row, }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>
                    5) Teléfono particular (fijo o celular): {preferencias.telefono_particular}
                  </Text>
                </View>
                <View style={{marginLeft: 30}}>
                  <View style={{...styles.row, paddingTop: 5 }}>
                    <Text style={{...styles.colToComplete, width: '100%'}}>Teléfono laboral (fijo o celular): {preferencias.telefono_laboral}</Text>
                  </View>
                </View>
              </View>


              {/* PUNTO 6 */}
              <View style={{ marginTop: 20 }}>
                <View style={{...styles.row, }}>
                  <Text style={{...styles.colToComplete, width: '100%'}}>
                    6) Dirección de Correo electrónico: {resource.email}
                  </Text>
                </View>
              </View>


              {/* PUNTO 7 */}
              <View style={{ marginTop: 20 }}>
                <View style={{...styles.row, }}>
                  <Text style={{width: '100%'}}>
                    7) Ubicación Geográfica: Indique en el plano correspondiente (A o B) la ubicación de su domicilio y el
nombre de las calles que lo rodean.-
                  </Text>
                </View>
              </View>

              {/* DECLARACION FINAL */}
              <View style={{ marginTop: 20 }}>
                <View style={{...styles.row, }}>
                  <Text style={{width: '100%'}}>
                    Declaro bajo juramento que los datos consignados precedentemente, son fidedignos. Asimismo, tendré por válidos y legalmente efectuadas todas las notificaciones que se practiquen en el domicilio constituido.
                  </Text>
                </View>
                <View style={{marginLeft: 60}}>
                  <View style={{...styles.row, paddingTop: 5 }}>
                    <Text style={{...styles.colLabel, width: '50%'}}></Text>
                    <Text style={{...styles.colLabel, width: '50%'}}>Saludo a Ud. atentamente. </Text>
                  </View>
                </View>
              </View>


              {/* FIRMAS */}
              <View style={{ marginTop: 120 }}>
                <View style={styles.row}>
                  <Text style={{...styles.colLabel, width: '60%'}}></Text>
                  <Text style={{...styles.colTopBorder, width: '40%', textAlign: 'right', paddingTop: 10}}>(firma y aclaración)</Text>
                </View>
              </View>

            </View>            

          </Page>
        </Document>
    );
};

export default RptDeclaracionJuradaObligado;